import React, {ReactElement, useEffect, useRef, useState} from "react";
import {Box, Fade, Grid2, IconButton, Stack} from "@mui/material";
import {ArrowLeftSvg, ArrowRightSvg, BulletGreenSvg, BulletWhiteSvg} from "@/pages/landing-page/utils/Svgs";

interface CrossfadeBoxProps {
    children: ReactElement[];
    idx?: number;
}

export const CrossfadeBox = ({ children, idx }: CrossfadeBoxProps) => {
    const [idx0, setIndex] = useState<number | null>(null);
    const [containerHeight, setContainerHeight] = useState<number | null>(null);
    const prev = () => setIndex((prevIndex) => ((prevIndex ?? 0) - 1 + children.length) % children.length);
    const next = () => setIndex((prevIndex) => ((prevIndex ?? 0) + 1) % children.length);

    const index = idx ?? idx0 ?? 0;

    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const updateWidth = () => {
            if (containerRef.current) {
                setContainerHeight(containerRef.current.scrollHeight);
            }
        };
        updateWidth();
        window.addEventListener("resize", updateWidth);
        return () => window.removeEventListener("resize", updateWidth);
    }, []);

    return (
        <Grid2 container direction="column">
            <Grid2>
                <Box sx={{ position: "relative", height: containerHeight }}>
                    {children.map((Child, i) => (
                        <Fade key={i} in={index === i} timeout={1000}>
                            <Box
                                ref={
                                    i === index
                                        ? (ref: any) => {
                                              containerRef.current = ref;
                                              if (ref?.scrollHeight > 0) {
                                                  setContainerHeight(ref?.scrollHeight);
                                              }
                                          }
                                        : undefined
                                }
                                sx={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    width: "100%"
                                }}
                            >
                                {Child}
                            </Box>
                        </Fade>
                    ))}
                </Box>
            </Grid2>
            {containerHeight && idx0 != null && (
                <Grid2 container justifyContent="center" width="100%">
                    <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 3 }}>
                        <IconButton onClick={prev}>
                            <ArrowLeftSvg />
                        </IconButton>

                        <Stack direction="row" spacing={1}>
                            {children.map((_, ci) => (
                                <IconButton key={ci} size="small" onClick={() => setIndex(ci)}>
                                    {ci === index ? <BulletGreenSvg /> : <BulletWhiteSvg />}
                                </IconButton>
                            ))}
                        </Stack>

                        <IconButton onClick={next}>
                            <ArrowRightSvg />
                        </IconButton>
                    </Stack>
                </Grid2>
            )}
        </Grid2>
    );
};
